export default "__VITE_ASSET__DL0rFAl8__"